module.exports = __webpack_public_path__ + "img/store_active.172fbdc7.png";